//#region
import axios from 'axios'
import { url, endPoint } from '../urls'
//#endregion

export function markDashboardFavourite(params) {
  let _url = url.backendHost + endPoint.users.markDashboardFavourite
  return axios.put(_url, params)
}

export function markReportFavourite(params) {
  let _url = url.backendHost + endPoint.users.markReportFavourite
  return axios.put(_url, params)
}

export function adminLogin(params) {
  let _url = url.backendHost + endPoint.users.adminLogin
  return axios.post(_url, params)
}

export function getUsersList(params) {
  let _url = url.backendHost + endPoint.users.getUsersList
  return axios.get(_url, { params })
}

export function createUser(params) {
  let _url = url.backendHost + endPoint.users.createUser
  return axios.post(_url, params)
}

export function updateUser(params) {
  let _url = url.backendHost + endPoint.users.updateUser
  return axios.put(_url, params)
}

export function deleteUser(params) {
  let _url = url.backendHost + endPoint.users.deleteUser
  return axios.put(_url, params)
}
export function getUserInfo(params) {
  let _url = url.backendHost + endPoint.userInfo.getUserInfoByUuid
  return axios.post(_url, params)
}
export function schoolReportStatus(params) {
  let _url = url.backendHost + endPoint.schoolReportStatus.schoolReportStatus
  return axios.get(_url, { params })
}
